import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SmartImage from "@/components/SmartImage";
import { Sparkles } from "lucide-react";

const ACCENT_BG = {
  terracotta: "bg-terracotta",
  sage: "bg-sage",
  ink: "bg-ink",
};

export default function Collections() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/collections")
      .then((r) => setItems(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="collections-page" className="max-w-6xl mx-auto px-6 md:px-12 py-16 md:py-24">
      <div className="label-eyebrow text-sage mb-3">Curated shelves</div>
      <h1 className="font-serif text-5xl sm:text-6xl tracking-tight">Collections.</h1>
      <p className="text-muted_ink mt-4 max-w-xl">
        Books grouped by mood, moment, or shared thread. Handpicked, small, and worth a browse.
      </p>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-8">
        {loading ? (
          <div className="text-muted_ink">Loading…</div>
        ) : items.length === 0 ? (
          <div className="text-muted_ink">No collections yet.</div>
        ) : items.map((c) => (
          <Link
            key={c.slug}
            to={`/collections/${c.slug}`}
            data-testid={`collection-${c.slug}`}
            className="group block relative overflow-hidden border border-edge bg-linen"
          >
            {c.cover_url && (
              <div className="aspect-[16/9] overflow-hidden">
                <SmartImage
                  src={c.cover_url}
                  alt=""
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
              </div>
            )}
            <div className="p-6 md:p-8">
              <div className={`inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest px-2 py-1 ${ACCENT_BG[c.accent] || "bg-ink"} text-paper`}>
                <Sparkles className="w-3 h-3" /> {c.book_count} book{c.book_count === 1 ? "" : "s"}
              </div>
              <h2 className="font-serif text-3xl mt-3 group-hover:text-terracotta transition-colors">{c.title}</h2>
              <p className="text-sm text-muted_ink mt-2 line-clamp-2">{c.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
